export type operation = {
    name: string;
    date: string;
    code: string;
};

export type accessStoreState = {
    selectedOperations: operation[];
    zipCodes: string[];
    selectedAgents: any[];
    budget: number;
    minAmount: number;
    maxAmount: number;
    campaignDurationMin: number;
    campaignDurationMax: number;
    cpmFlated: number;
    operationsMedias: {
        code: string;
        priority: number;
        threshold: number;
    }[];
    campaignDates: campaignDelay | campaignDates;
    bannerPreviewUrl: string;
    avgCapping: number;
    avgCtr: number;
    purchaseMinDate: string; //2025-12-20
    reduction: number;
    reductionMessage: string;
    diffusionDate: string;
};

type campaignDelay = {
    type: campaignDateTypes.DELAY;
    purchase_delay: number;
    start_date: null;
    end_date: null;
};

type campaignDates = {
    type: campaignDateTypes.DATES;
    purchase_delay: null;
    start_date: string;
    end_date: string;
};

export enum campaignDateTypes {
    DELAY = 'delay',
    DATES = 'dates',
}
